import { useState } from 'react';
import { SelectionInfo } from 'dragonmouse-shared/devigner';
import { Frame } from 'dragonmouse-shared/interfaces';
import { getElementName } from 'utils';
import CollapsibleSection from 'components/Widget/CollapsibleSection';
import Comments from '../Comments';
import ColorEditControl from './ColorEditControl';
import ImageEditControl from './ImageEditControl';
import OffsetControl from './OffsetControl';
import PaddingEditControl from './PaddingEditControl';
import TypographyEditControl from './TypographyEditControl';
import * as S from './styles';

interface ElementInfoProps {
	frame: Frame;
	selectionInfo: SelectionInfo;
}

const ElementInfo = ({ frame, selectionInfo }: ElementInfoProps) => {
	const [editsCollapsed, setEditsCollapsed] = useState(false);
	const [commentsCollapsed, setCommentsCollapsed] = useState(false);

	const elementName = getElementName(selectionInfo.element);
	const isDesignSystemElement = selectionInfo.element.tagName.toLowerCase().startsWith('ds-');
	const dsTagName = isDesignSystemElement
		? `<${selectionInfo.element.tagName.toLowerCase()}>`
		: null;
	const elementId = selectionInfo.dataset?.mcElementId ?? selectionInfo.element.id;
	const isImage = !!selectionInfo.imageUrl;

	return (
		<S.Container>
			<S.HeaderBase>
				<div>
					<S.ElementName>{elementName}</S.ElementName>
					{dsTagName && <S.DsComponentName>{dsTagName}</S.DsComponentName>}
				</div>
			</S.HeaderBase>

			<CollapsibleSection
				label="Edits"
				isCollapsed={editsCollapsed}
				onToggle={() => setEditsCollapsed((v) => !v)}
			>
				{/* key={elementId} remounts edit controls when selection changes so their
				    local useState (e.g. picker color) reflects the newly selected element. */}
				<S.EditsWrapper key={elementId}>
					{isImage && <ImageEditControl frame={frame} selectionInfo={selectionInfo} />}
					<ColorEditControl frame={frame} selectionInfo={selectionInfo} />
					<TypographyEditControl frame={frame} selectionInfo={selectionInfo} />
					<PaddingEditControl frame={frame} selectionInfo={selectionInfo} />
					<OffsetControl frame={frame} selectionInfo={selectionInfo} />
				</S.EditsWrapper>
			</CollapsibleSection>

			<CollapsibleSection
				label="Comments"
				isCollapsed={commentsCollapsed}
				onToggle={() => setCommentsCollapsed((v) => !v)}
			>
				<S.CommentsWrapper>
					<Comments frame={frame} filterElementId={elementId} />
				</S.CommentsWrapper>
			</CollapsibleSection>
		</S.Container>
	);
};

export default ElementInfo;
